<template>
    <v-app>
        <div class="main-content">
            <router-view />
        </div>
    </v-app>
</template>

<script>

export default {
  data() {
  },
  methods: {
    home() {
        this.$router.push('/')
    },  
  },

};
</script>
